import { BehaviorSubject, isObservable } from 'rxjs';
import type { InputsAndDropdownsDrawerOptions } from './components/InputsAndDropdownsDrawer/types';
import type { EntityAdminDrawerOptionsView, EntityAdminRecord } from './types';

export function isDrawerOptionsObservable<TDrawerRecord extends EntityAdminRecord>(
  source: EntityAdminDrawerOptionsView<TDrawerRecord> | null | undefined
): source is Extract<EntityAdminDrawerOptionsView<TDrawerRecord>, { subscribe: unknown }> {
  return isObservable(source);
}

/** Current options for synchronous callers. Observables other than BehaviorSubject have no current value. */
export function readDrawerOptions<TDrawerRecord extends EntityAdminRecord>(
  source: EntityAdminDrawerOptionsView<TDrawerRecord> | null | undefined
): InputsAndDropdownsDrawerOptions<TDrawerRecord> | undefined {
  if (source == null) {
    return undefined;
  }
  if (isObservable(source)) {
    return source instanceof BehaviorSubject ? source.getValue() : undefined;
  }
  return source;
}
